import apiClient from '../connections/api'

export default {
    getMachines: () => {
        return apiClient.get('/machines/project')
    },
    getAllMachines: () => {
        return apiClient.get('/machines')
    },
    getAllMachinesByModel: (idobra, model) => {
        return apiClient.get('/machines/by-model', { params: { idobra, model } })
    },
    /* getMachineByEquid: (equid) => {
        const requestBody = {
            equid: equid,
        }
        return apiClient.post('/machines/readMachineByEquid', requestBody)
    }, */
    getMachineBySiteId: (siteId) => {
        return apiClient.get('/machines/by-site', { params: { siteId } })
    },
    getPMList: () => {
        return apiClient.get('/icv/petitionFiles')
    },
    getFiles: (fileName) => {
        const requestBody = {
            fileName: fileName
        }
        return apiClient.post('/icv/petitionFile', requestBody)
    },
    getSites: () => {
        return apiClient.get('/sites/getSites')
    },
    getPautas: () => {
        return apiClient.get('icv/getPautas')
    },
    getHeaderPauta: ({ idpm, typepm }) => {
        const requestBody = {
            idpm, typepm
        }
        return apiClient.post('icv/getHeaderPauta', requestBody)
    },
    getStructsPauta: ({ idpm, typepm }) => {
        const requestBody = {
            idpm, typepm
        }
        return apiClient.post('icv/getStructsPauta', requestBody)
    },
    getStructsPauta2: (idpm, typepm) => {
        const requestBody = {
            idpm, typepm
        }
        return apiClient.post('/icv/getStructsPauta', requestBody)
    },
    saveMachineDataById: (machine) => {
        const requestBody = {
            machine
        }
        return apiClient.post('/machines/saveMachineDataById', requestBody)
    }
}
